import React, { useState, useEffect } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import NotDefinedIcon from '../Icons/NotDefinedIcon';
import BugIcon from '../Icons/BugIcon';
import IssueIcon from '../Icons/IssueIcon';
import SupportIcon from '../Icons/SupportIcon';
import { useHumanHandoverStore } from '@/stores/humanHandover/humanHandoverStore';

const StatusMenu = ({ onStatusChange, className = '', currentCategoryId = null }) => {

    const { categories } = useHumanHandoverStore((state) => state);
    const [selectedStatus, setSelectedStatus] = useState(categories[0]);

  
  useEffect(() => {
    const currentCategory = categories.find(
      (category) => category.id === currentCategoryId
    );
    setSelectedStatus(currentCategory);
  }, [currentCategoryId, categories]);


  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    if (onStatusChange) {
      onStatusChange();
    }
  };

  return (
    <div className={className}>
      <Menu>
        <MenuButton className="flex p-v3-xxs items-center gap-[10px] rounded-v3-sm bg-v3-black-subtle hover:bg-v3-black-border transition-colors">
          {selectedStatus?.icon && (
            typeof selectedStatus.icon === 'string' ? (
              <img src={selectedStatus.icon} alt={selectedStatus.name} className="w-6 h-6" />
            ) : (
              <selectedStatus.icon className="w-6 h-6" />
            )
          )}
        </MenuButton>
        <MenuItems className="absolute top-full -left-v3-sm mt-v3-md z-[99999] w-[205px] p-v3-xxs flex flex-col items-start rounded-v3-lg bg-white shadow-v3-double">
          <div className="w-full">
            {categories.map((category, index) => (
              <MenuItem key={index}>
                {({ active }) => (
                  <button
                    onClick={() => handleStatusChange(category)}
                    className={`w-full flex items-center gap-v3-sm p-v3-xs text-left text-sm font-medium transition-colors rounded-v3-xl hover:bg-v3-black-card ${
                      category.id === currentCategoryId ? 'bg-v3-black-subtle' : 'bg-white'
                    }`}
                  >
                    {category.icon && (
                      typeof category.icon === 'string' ? (
                        <img src={category.icon} alt={category.name} className="w-6 h-6" />
                      ) : (
                        <category.icon className="w-6 h-6" />
                      )
                    )}
                    <span className='font-inter-variable text-sm text-medium text-v3-black-max'>{category.name}</span>
                  </button>
                )}
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Menu>
    </div>
  );
};

export default StatusMenu;
